"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "Добавить пользовательский цвет",
  Apply: "Применить",
  "Apply color": "Применить цвет",
  Automatic: "Авто",
  Cancel: "Отмена",
  "Cancel color": "Отменить выбор цвета",
  Change: "Изменить",
  Custom: "Настраиваемый",
  "Custom color picker": "Средство выбора пользовательских цветов",
  "Invalid hex value": "Недопустимое шестнадцатеричное значение",
  Remove: "Удалить",
  "Select color {color}": ["Выбор цвета: ", ["color"]],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["Достигнут лимит пользовательских цветов (", ["maxCustomColors"], "). Чтобы добавить цвет, сначала удалите один из существующих."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map